import { isBeneficiaryFilledForCartItem } from '@/services/beneficiaryRules/beneficiaryRules'
import { isBeneficiaryFilledForCartItem as isBeneficiaryFilledForCartItemRo } from '@/services/beneficiaryRules/beneficiaryRulesRo'

export const getters = {
  isBeneficiaryQuoteComplete (state, getters, rootState, rootGetters) {
    const items = rootGetters['checkout/getBeneficiaryItems']
    const purchaser = rootGetters['customer/getPurchaser']

    return items.every((item) => {
      const quote = state.quote[item.uid]

      return (
        quote &&
        quote.beneficiary.length === item.quantity &&
        quote.beneficiary?.every(bIndex => isBeneficiaryFilledForCartItem(state.beneficiaries[bIndex], item, purchaser))
      )
    })
  },

  isBeneficiaryQuoteCompleteRo (state, getters, rootState, rootGetters) {
    const items = rootGetters['checkout/getBeneficiaryItems']
    const purchaser = rootGetters['customer/getPurchaser']

    return items.every((item) => {
      const quote = state.quote[item.uid]

      return (
        quote &&
        quote.beneficiary.length === item.quantity &&
        quote.beneficiary?.every(bIndex => isBeneficiaryFilledForCartItemRo(state.beneficiaries[bIndex], item, purchaser))
      )
    })
  },

  getQuoteForMutation (state) {
    return Object.entries(state.quote).reduce((acc, [itemUid, quote]) => {
      quote.beneficiary?.forEach((index) => {
        const {
          isBeneficiary,
          isChild,
          isForeigner,
          isOtherAddress,
          isOtherShippingAddress,
          invoiceType,
          regulation,
          company,
          nip,
          firstnameInvoice,
          lastnameInvoice,
          addressStreetInvoice,
          addressHouseNumberInvoice,
          addressApartmentNumberInvoice,
          addressPostcodeInvoice,
          addressCityInvoice,
          isInvoice,
          mediclubCardId,
          statementAgreement,
          _typename,
          hasOnlyShippingProducts,
          hasOnlyTrainingProductsFromRehasport,
          createdAt,
          region,
          country,
          ...personalData
        } = state.beneficiaries[index]

        acc.push({
          itemUid,
          personalData,
        })
      })

      return acc
    }, [])
  },

  isDuplicatedBeneficiary (state) {
    return (beneficiaryIndex, itemUid, editIndex = null) => {
      const item = state.quote[itemUid]

      if (editIndex !== null && item.beneficiary[editIndex] === beneficiaryIndex) {
        return false
      }

      if (item.type === 'MedicalPackageCartItem') {
        const beneficiaries = Object
          .values(state.quote)
          .filter(quote => quote.group === item.group)
          .flatMap(quote => quote.beneficiary)

        return beneficiaries.includes(beneficiaryIndex)
      }

      return false
    }
  },
}
